import type { ReactNode } from 'react';
import React, { useState } from 'react';
import { useIntl, FormattedMessage } from 'react-intl-next';

import { useIsReducedMotion } from '@atlaskit/motion';
import { token } from '@atlaskit/tokens';
import {
	Spotlight,
	SpotlightManager,
	SpotlightTarget,
	SpotlightTransition,
} from '@atlaskit/onboarding';

import { messages } from '../messages';

type LoomScriptSpotlightProps = {
	children: ReactNode;
	targetId: string;
	onDismiss?: () => void;
};

export const LoomScriptSpotlight = ({
	children,
	targetId,
	onDismiss,
}: LoomScriptSpotlightProps) => {
	const intl = useIntl();
	const isReducedMotion = useIsReducedMotion();
	const [visible, setVisible] = useState(true);

	const dismiss = () => {
		setVisible(false);
		onDismiss?.();
	};

	return (
		<SpotlightManager blanketIsTinted={false}>
			<SpotlightTarget name={targetId}>{children}</SpotlightTarget>

			<SpotlightTransition>
				{visible && (
					<Spotlight
						target={targetId}
						key={targetId}
						testId={targetId}
						targetRadius={4}
						dialogWidth={280}
						pulse={!isReducedMotion}
						targetBgColor={token('color.text.inverse')}
						heading={intl.formatMessage(messages.spotlightTitle)}
						actions={[{ text: intl.formatMessage(messages.okButton), onClick: dismiss }]}
						shouldWatchTarget
						dialogPlacement="left bottom"
					>
						<FormattedMessage {...messages.spotlightDescription} />
					</Spotlight>
				)}
			</SpotlightTransition>
		</SpotlightManager>
	);
};
